import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CloudUpload, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/lib/api";
import { clearGuestProject, migrateOldGuest, readGuestProject } from "@/hooks/useProjectStore";

export const GuestImportBanner = ({ onSave }) => {
  const [guest, setGuest] = useState(readGuestProject);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    migrateOldGuest().then(() => setGuest(readGuestProject()));
  }, []);

  if (!guest) return null;

  const discard = () => { clearGuestProject(); setGuest(null); };
  const save = async () => {
    setSaving(true);
    try {
      await onSave(guest);
      clearGuestProject();
    } catch (e) {
      toast.error(errorMessage(e));
      setSaving(false);
    }
  };

  return (
    <div className="fade-up mt-8 flex flex-col gap-4 rounded-2xl border-2 border-primary/40 bg-secondary/60 p-5 sm:flex-row sm:items-center sm:justify-between" data-testid="guest-import-banner">
      <div>
        <p className="font-display text-lg font-bold">“<span data-testid="guest-import-name">{guest.name}</span>” was set up on this computer before signing in</p>
        <p className="text-sm text-muted-foreground">Is it yours? Save it to My projects so it opens on any computer.</p>
      </div>
      <div className="flex gap-2">
        <Button variant="ghost" className="rounded-full" onClick={discard} disabled={saving} data-testid="guest-import-discard-button">Discard</Button>
        <Button className="rounded-full" onClick={save} disabled={saving} data-testid="guest-import-save-button">
          {saving ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <CloudUpload className="mr-1.5 h-4 w-4" />}Save to my projects
        </Button>
      </div>
    </div>
  );
};
